export enum EventType {
  CONNECT = 'connection',
  DATA = 'data',
  ERROR = 'error',
  CLOSE = 'close',
}
